import { FC } from 'react';

import { Grid } from '@mui/material';

import MediaUploadSection from '../../../sharedModules/mediaUpload/MediaUploadSection';
import type { UseReceivingDetailResult } from '../hooks/useReceivingDetail';

interface ReceivingPhotosSectionProps {
  detail: UseReceivingDetailResult;
  stagedDocuments: File[];
  onStagedDocumentsChange: (files: File[]) => void;
  poValidated: boolean;
  showEquipmentPhotos: boolean;
}

const ReceivingPhotosSection: FC<ReceivingPhotosSectionProps> = ({
  detail,
  stagedDocuments,
  onStagedDocumentsChange,
  poValidated,
  showEquipmentPhotos,
}) => {
  const { documentPhotos, packagePhotos, equipmentPhotos, uploads, uploadPhotos, removePhoto } = detail;
  // Two photo columns when equipment is hidden, three when it is shown - no empty cell on desktop.
  const photoColumnWidth = showEquipmentPhotos ? 4 : 6;

  return (
    <Grid container spacing={2} style={{ marginTop: 16, marginBottom: 24 }}>
      <Grid item xs={12} md={photoColumnWidth}>
        <MediaUploadSection
          label={stagedDocuments.length > 0 ? 'Packing slip photos (not scanned yet)' : 'Packing slip photos'}
          files={stagedDocuments}
          onChange={onStagedDocumentsChange}
          existingMedia={documentPhotos}
          onRemoveExisting={removePhoto}
          allowVideo={false}
          required
        />
      </Grid>
      <Grid item xs={12} md={photoColumnWidth}>
        <MediaUploadSection
          label={uploads.includes('package') ? 'Package photos (uploading...)' : 'Package photos'}
          files={[]}
          onChange={(files) => uploadPhotos(files, 'package')}
          existingMedia={packagePhotos}
          onRemoveExisting={removePhoto}
          allowVideo={false}
          disabled={!poValidated}
          required
        />
      </Grid>
      {showEquipmentPhotos && (
        <Grid item xs={12} md={photoColumnWidth}>
          <MediaUploadSection
            label={uploads.includes('equipment') ? 'Equipment photos (uploading...)' : 'Equipment photos'}
            files={[]}
            onChange={(files) => uploadPhotos(files, 'equipment')}
            existingMedia={equipmentPhotos}
            onRemoveExisting={removePhoto}
            allowVideo={false}
            disabled={!poValidated}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ReceivingPhotosSection;
